import React, { useState, useEffect } from 'react';
import {Link, useLocation} from 'react-router-dom';
import Styles from '../styles/Navbar.module.css';
import logo from '../imgs/logoImg.png';


const Navbar = () => {
  const location = useLocation();
  const [navHeight, setNavHeight] = useState(0);

  useEffect(() => {
    setNavHeight(document.getElementById('my-nav').offsetHeight);
  }, []);

  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > navHeight);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [navHeight]);
     const [isExpanded, setIsExpanded] = useState(false);
     const [isServicesOpen, setIsServicesOpen] = useState(false);
     const [suppressServicesHover, setSuppressServicesHover] = useState(false);

useEffect(() => {
  setIsExpanded(false);
  setIsServicesOpen(false);
  setIsScrolled(window.scrollY > navHeight);
}, [location.pathname, location.hash, navHeight]);

const handleToggleClick = () => {
  setIsExpanded(!isExpanded);
  
};
const handleLinkClick = () => {
  setIsExpanded(false);
  setIsServicesOpen(false);
};

const handleServiceLinkClick = () => {
  setIsExpanded(false);
  setIsServicesOpen(false);
  setSuppressServicesHover(true);
};

const servicePaths = ['/Concrete', '/Paint', '/Porches-Decks-Fences', '/Roofing', '/StonePatio', '/BlockFoundation'];
const isServiceRoute = servicePaths.includes(location.pathname);
const isActivePath = (path) => location.pathname === path;
const isQuoteRoute = location.pathname === '/ContactUs' && location.hash.toLowerCase() === '#estimate';




return  (
  <nav id="my-nav" className={`${Styles.navbar} ${isExpanded && Styles["navbar-expanded"]} ${isScrolled && Styles["navbar-scrolled"]}`}>
    <div className={Styles.logoImg}>
      <Link to='/' onClick={handleLinkClick}><img src={logo} alt='Dino Construction' width="155" height="62"/></Link>
    </div>
    <ul className={`${Styles.navbarItems} ${isExpanded && Styles["navbarItems-expanded"]}`}>
      <li
        className={`${Styles.servicesItem} ${isServicesOpen ? Styles.servicesOpen : ''} ${isServiceRoute ? Styles.activeItem : ''} ${suppressServicesHover ? Styles.suppressServicesHover : ''}`}
        onMouseEnter={() => !suppressServicesHover && setIsServicesOpen(true)}
        onMouseLeave={() => {
          setIsServicesOpen(false);
          setSuppressServicesHover(false);
        }}
      >
        <button
          className={Styles.servicesButton}
          type="button"
          onClick={() => {
            setSuppressServicesHover(false);
            setIsServicesOpen((open) => !open);
          }}
          aria-expanded={isServicesOpen}
        >
          Services
        </button>
        <ul className={Styles.servicesOptions}>
          <li><Link className={isActivePath('/Concrete') ? Styles.activeSubLink : ''} to='/Concrete' onClick={handleServiceLinkClick}>Concrete</Link></li>
          <li><Link className={isActivePath('/Paint') ? Styles.activeSubLink : ''} to='/Paint' onClick={handleServiceLinkClick}>Paint</Link></li>
          <li><Link className={isActivePath('/Porches-Decks-Fences') ? Styles.activeSubLink : ''} to='/Porches-Decks-Fences' onClick={handleServiceLinkClick}>Decks/Fences</Link></li>
          <li><Link className={isActivePath('/Roofing') ? Styles.activeSubLink : ''} to='/Roofing' onClick={handleServiceLinkClick}>Roofing</Link></li>
          <li><Link className={isActivePath('/StonePatio') ? Styles.activeSubLink : ''} to='/StonePatio' onClick={handleServiceLinkClick}>Stone Patio</Link></li>
          <li><Link className={isActivePath('/BlockFoundation') ? Styles.activeSubLink : ''} to='/BlockFoundation' onClick={handleServiceLinkClick}>Block Foundation</Link></li>
        </ul>
      </li>
      <li><Link className={isActivePath('/Gallery') ? Styles.activeLink : ''} to='/Gallery' onClick={handleLinkClick}>Gallery</Link></li>
      <li><Link className={isActivePath('/AboutUs') ? Styles.activeLink : ''} to='/AboutUs' onClick={handleLinkClick}>About Us</Link></li>
      <li><Link className={isActivePath('/ContactUs') && !isQuoteRoute ? Styles.activeLink : ''} to='/ContactUs' onClick={handleLinkClick}>Contact</Link></li>
      <li className={Styles.quoteItem}><Link className={isQuoteRoute ? Styles.activeQuote : ''} to='/ContactUs#Estimate' onClick={handleLinkClick}>Request Quote</Link></li>
    </ul>
    <button className={Styles.hamburger} onClick={handleToggleClick} aria-label="Toggle navigation" aria-expanded={isExpanded}>
      <div className={Styles.line}></div>
      <div className={Styles.line}></div>
      <div className={Styles.line}></div>
    </button>
  </nav>
);
};

export default Navbar;
